import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import WarningIcon from '@nv/images/design/warning-icon'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmQrRequest.module.scss'

export const ConfirmQrRequest = ({ confirm }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('buttons.confirmRequest'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.ok'), onClick: confirm },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <WarningIcon />
      <span>{t('auth.authApp.form.confirmRequest')}</span>
    </div>
  )
}
